import actions from "./actions";

const stateDefault = {
    notes: [],
    note: []
};
export default function notesReducer(state = stateDefault, action: { type: string; payload: any; }): any {
    switch (action.type){
        case actions.SET_NOTES:
            return {...state, notes:action.payload};
        case actions.SET_NOTE:
            return {...state, note:action.payload};
        default:
            return state
    }
}